import React from "react";
import PropTypes from "prop-types";
import { compose } from "recompose";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Actions from "../../../../store/actions/index";
import { withStyles, Typography } from "@material-ui/core";
import SettingsIcon from '@material-ui/icons/Settings';
import t from "../../../../languages/pl";
import useStyles from "./buttonGroupStyle";
import Zoning from "./CarSettings/Zoning";
import PrivateWorkingsHours from "./CarSettings/PrivateWorkingHours";
import ContractedMileageMonitor from "./CarSettings/ContractedMileageMonitor";
import CarParameters from "./CarSettings/CarParameters";
import CarDamage from "./CarSettings/CarDamage/CarDamage";

const CarSettings = props => {
    const { classes, carId, registrationNo, zones, individualWorkingHours,
            contractedMileage, carParameters, possibleParameters, carType } = props;

    const handleZoneClick = () => {
        props.getZones(carId);
    };

    const handleZoneSubmit = (zones, assignIds) => {
        let carIds = [carId, ...assignIds];
        props.patchZones(carIds, zones);
        props.clearZones();
    };

    const handleDefaultZone = () => {
        props.clearZones();
        props.getZones(carId, true);
    };

    const handlePrivateHoursOpen = () => {
        props.getIndividualWorkingHours(carId);
    };

    const handlePrivateHoursSubmit = (privateWorkingHoursMode, startTime, endTime) => {
        props.patchIndividualWorkingHours(carId, privateWorkingHoursMode,  startTime, endTime);
    };

    const handleContractedMileageOpen = () => {
        props.getContractedMileage(carId);
    };

    const handleContractedMileageSubmit = (data) => {
        props.patchContractedMileage(carId, data);
    };

    const handleCarParametersSubmit = (data) => {
        props.patchCarParameters(carId, data);
    };

    return (
        <div className={classes.container}>
            <div className={classes.header}>
                <SettingsIcon style={{ marginRight: 5 }} />
                <Typography variant="body1">{t.carSettings}</Typography>
            </div>
            <div className={classes.content}>
                <Zoning
                    name={registrationNo}
                    zones={zones.lista_rejon}
                    carCoords={zones.pozycja}
                    carType={carType}
                    dialogOpenCallback={handleZoneClick}
                    onSubmit={handleZoneSubmit}
                    onCancel={() => props.clearZones()}
                    onDefaultZone={handleDefaultZone}
                />
                <ContractedMileageMonitor
                    name={registrationNo}
                    data={contractedMileage}
                    onDialogOpen={handleContractedMileageOpen}
                    onSubmit={handleContractedMileageSubmit}
                />
                <PrivateWorkingsHours
                    name={registrationNo}
                    onDialogOpen={handlePrivateHoursOpen}
                    onSubmit={handlePrivateHoursSubmit}
                    startTime={individualWorkingHours.godzina_start}
                    endTime={individualWorkingHours.godzina_koniec}
                    isPrivateHoursMode={individualWorkingHours.godziny_indywidualne}
                />
                <CarParameters
                    name={registrationNo}
                    onDialogOpen={() => props.getCarParameters(carId)}
                    data={carParameters}
                    possibleOptions={possibleParameters}
                    onSubmit={handleCarParametersSubmit}
                />
                <CarDamage
                    name={registrationNo}
                    onDialogOpen={() => props.getCarDamage(carId)}
                    onSubmit={(damage) => props.putCarDamage(carId, damage)}
                />
            </div>
        </div>
    );
};

CarSettings.propTypes = {
    classes: PropTypes.object,
    carId: PropTypes.number,
    registrationNo: PropTypes.string,
    carType: PropTypes.string,
    //redux
    zones: PropTypes.object,
    getZones: PropTypes.func,
    clearZones: PropTypes.func,
    individualWorkingHours: PropTypes.object,
    getIndividualWorkingHours: PropTypes.func,
    contractedMileage: PropTypes.object,
    getContractedMileage: PropTypes.func,
    patchContractedMileage: PropTypes.func,
    getCarParameters: PropTypes.func,
    carParameters: PropTypes.object,
    getCarDamage: PropTypes.func,
    putCarDamage: PropTypes.func,
    possibleParameters: PropTypes.object,
    patchCarParameters: PropTypes.func,
    patchIndividualWorkingHours: PropTypes.func,
    patchZones: PropTypes.func
};

const mapStateToProps = (state) => ({
    zones: state.carsReducer.zones,
    individualWorkingHours: state.carsReducer.individualWorkingHours,
    contractedMileage: state.carsReducer.contractedMileage,
    carParameters: state.carsReducer.carParameters,
    possibleParameters: state.carsReducer.possibleCarParameters,
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(Actions, dispatch);
};

export default  compose(
    withStyles(useStyles),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(CarSettings);
